module.exports = __webpack_public_path__ + "img/light-frame.6136e0df.png";